
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface StudentFormHeaderProps {
  isEditing: boolean;
}

const StudentFormHeader: React.FC<StudentFormHeaderProps> = ({ isEditing }) => {
  const navigate = useNavigate();
  
  return (
    <div className="mb-6">
      <Button 
        variant="outline" 
        onClick={() => navigate("/students")}
        className="mb-4"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Students
      </Button>
      <h2 className="text-3xl font-bold tracking-tight text-nalc-dark dark:text-white">
        {isEditing ? "Edit Student" : "New Student"}
      </h2>
      <p className="text-muted-foreground mt-1">
        {isEditing ? "Update student information and programs" : "Add a new student with programs"}
      </p>
    </div>
  );
};

export default StudentFormHeader;
